import { environmentBase } from 'sc-common';

export const environment = environmentBase({
    production: true,
    project: 'content-manager'
});
